import isNumber from 'is-number'
import countries from '@/libs/countries'
import i18n from '@/plugins/i18n/index.js'
// return true if the value is valid else return false or message
const rules = {}

rules.email = value => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!value) return true
  return pattern.test(value) || (i18n.t('rules.validEmail'))
}

rules.isANumber = value => {
  if (value !== 0 && !value) return true
  return isNumber(value) || (i18n.t('rules.onlyNumbers'))
}
rules.min8 = (value) => {
  return (value && value.length >= 8) || (i18n.t('rules.passwordMin8'))
}

rules.onlyNumbers = (value) => {
  const pattern = /^[0-9]+$/
  if (!value) return true
  return pattern.test(value) || (i18n.t('rules.onlyNumbers'))
}

rules.phoneNumber = (value) => {
  const invalidMessage = (i18n.t('rules.validPhone'))
  const trimmedValue = value.trim()
  if (!trimmedValue) return invalidMessage
  const plusSign = trimmedValue.charAt(0)
  const parenthesesRegex = /\(([^)]+)\)/
  const countryCode = parenthesesRegex.exec(trimmedValue)[1]
  const country = countries.find(item => item.number === countryCode)
  const phone = trimmedValue.split(')')[1]
  return (plusSign === '+' && country && phone && rules.onlyNumbers(phone)) || invalidMessage
}

rules.zipCode = (value) => {
  if (!value) return true
  const pattern = /^[0-9]{5}(?:-[0-9]{4})?$/
  return pattern.test(value) || 'zipcode invalido'
}

rules.required = (value) => {
  let success = (i18n.t('general.required'))
  if (value !== undefined && value !== null) {
    if (Array.isArray(value)) {
      if (value.length > 0) success = true
    } else if (typeof value === 'object' && value !== null && value &&
      // https://stackoverflow.com/a/32108184/7712185
      Object.entries(value).length !== 0) {
      success = true
    } else if (typeof value === 'string' && value.length > 0 && value.trim().length > 0) {
      success = true
    } else if (typeof value === 'number') {
      success = true
    }
  }
  return success
}

rules.url = value => {
  // https://regexr.com/3e6m0
  // eslint-disable-next-line
  const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?|^((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]):[0-9]{4}\/*/
  if (value === '') return true
  return pattern.test(value) || 'Url inválida'
}

rules.minimumAmount = (value = 0, minimumAmount = 0) => {
  if (!rules.isANumber(value)) return (i18n.t('rules.onlyNumbers'))
  return parseFloat(value) >= minimumAmount || `Debes ingresar un número mayor o igual a ${minimumAmount}`
}

rules.keybeLink = value => {
  const regex = /{{keybe}}/g
  return regex.test(value) || 'Debes incluir al menos el enlace de Keybe'
}

export default rules
